<template>
    <div>
        <form method="post" :action="action_route" id="get-email-form" class="row">
            <input type="hidden" name="_token" v-bind:value="csrf">

            <div class="col-12">
                <div class="form-group">
                    <input type="email" class="form-control" id="email" name="email" v-model="email"
                           :aria-label="$lang('Adres e-mail')" :placeholder="$lang('Adres e-mail')">
                    <div class="mt-1 text-danger"><small v-if="error_message !== ''">{{error_message}}</small></div>
                    <button type="submit" class="btn btn-primary mt-3 float-right" :disabled="!emailValid">
                        {{$lang('Dalej')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "person-get-email-form",
    props: {
        action_route: {type: String, required: true},
        csrf: {type: String, required: true},
        error_message: {type: String, required: false, default: ''}
    },
    data() {
        return {
            email: null,
        }
    },
    computed: {
        emailValid() {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(this.email).toLowerCase());
        }
    }
}
</script>
